import { LearningActivityStudioVersionHistoryPage } from '@hendrx/core/learningActivity/pages/LearningActivityStudioVersionHistoryPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/studio/learning-activity/edit/$learningActivityDraftId/versions/')({
  component: RouteComponent
});

function RouteComponent() {
  const { learningActivityDraftId } = Route.useParams();
  return <LearningActivityStudioVersionHistoryPage learningActivityDraftId={learningActivityDraftId} />;
}
